export const getMediaDuration = (file): Promise<number> => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const media = new Audio(url)
    media.onloadedmetadata = () => {
      resolve(media.duration as number)
      URL.revokeObjectURL(url)
    }
    media.onerror = (error) => {
      reject(error)
      URL.revokeObjectURL(url)
    }
  })
}
